import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export default async function updateResourcesFromSettingProfile(updates) {
  const apiPath = `resource/update-resources-from-setting-profile`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: updates,
    // isLocalApiRequest: true, // Set to true for local API requests
  });

  const response = await axios(signedRequest);

  return response.data;
}
